import { useTranslation } from 'react-i18next';
import Input from '../../../../components/forms/input.component';
import Icon from '../../../../components/forms/icon.component';

function QuickReplyBtn({ errors, register, watch, index, onDelete, type }: any) {
  const { t } = useTranslation();

  const handleKeyDown = (e: any, maxLength: number) => {
    const currentLength = e.target.value.length;
    if (currentLength >= maxLength && e.key !== 'Backspace' && e.key !== 'Delete') {
      e.preventDefault();
    }
  };

  return (
    <div className="border p-7 mt-4">
      <div className="mb-2">
        {type === 'QUICK_REPLY' && (
          <>
            <Icon icon="ki-send" size="fs-1 me-2" />
            {t('templates.wa.create.quick-reply')}
          </>
        )}
        {type === 'QUICK_REPLY_DISABLE_MKT' && (
          <>
            <Icon icon="ki-send" size="fs-1 me-2" />
            {t('templates.wa.create.quick-reply-disable')}
          </>
        )}
      </div>
      <div className="d-flex flex-column">
        <div className="d-flex align-items-center">
          <div className="flex-grow-1 me-2">
            <Input
              label={t('templates.wa.create.text-btn-label')}
              currentLength={watch(`buttons.buttons.${index}.text`)?.length}
              requiredIndicator="required"
              maxLength={25}
              placeholder={t('templates.wa.create.body-placeholder')}
              errors={errors}
              onKeyDown={(e: any) => handleKeyDown(e, 25)}
              {...register(`buttons.buttons.${index}.text`, {
                required: true,
                maxLength: { value: 25, message: '25' },
                setValueAs: (value: any) => value.trim()
              })}
            />
          </div>
          <button type="button" className="btn btn-light-danger btn-icon" onClick={onDelete}>
            <Icon icon="ki-trash" size="fs-2x" />
          </button>
        </div>
        {type === 'QUICK_REPLY_DISABLE_MKT' && (
          <div className="alert alert-warning mt-2">
            <p className="m-0">{t('templates.wa.create.quick-reply-disable-warning')}</p>
          </div>
        )}
      </div>
    </div>
  );
}
export default QuickReplyBtn;
